import {
  Button,
  Container,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import TabletAndroidIcon from "@mui/icons-material/TabletAndroid";
import CreateCompany from "./CreateCompany";
import CreateDevice from "./CreateDevice";
import axios from "axios";
import { env, url } from "../MainPage/MainPage";

const useConfigPanel = () => {
  const [menu, handleMenu] = useState("");
  const [user, handleUser] = useState("");
  const [password, handlePassword] = useState("");

  const goBack = () => handleMenu("");

  const login = async () => {
    const form = { user, password };
    try {
      const response = await axios.post(`${url[env]}/login`, form);
      if (response.status === 200) {
        handleMenu("create-company");
      }
    } catch (error) {
      if (error.response.status === 401) {
        alert("Senha ou login invalidos");
      }
    }
  };

  const [listMenu] = useState([
    {
      label: "Cadastrar empresa",
      value: "create-company",
      icon: <AddBusinessIcon />,
    },
    {
      label: "Cadastrar dispositivo",
      value: "create-device",
      icon: <TabletAndroidIcon />,
    },
  ]);

  return {
    menu,
    handleMenu,
    listMenu,
    goBack,
    login,
    user,
    password,
    handleUser,
    handlePassword,
  };
};

const ConfigPanel = () => {
  const { menu, login, goBack, handlePassword, password, user, handleUser } =
    useConfigPanel();

  if (menu === "create-company") return <CreateCompany goBack={goBack} />;

  return (
    <Container>
      <Grid
        container
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{ height: "80vh" }}
        // spacing={2}
      >
        <Grid item>
          <Typography variant="h3" marginBottom={12}>
            LOGIN - CONFIGURAR BOX
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              value={user}
              label="login"
              fullWidth
              onChange={(e) => handleUser(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={password}
              label="password"
              type="password"
              fullWidth
              onChange={(e) => handlePassword(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Button onClick={login}>ENTRAR</Button>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ConfigPanel;
